import React, { ReactNode, useState } from "react";
import s from "./Container.module.scss";
import {FontIcon} from "../../FontIcon";

interface IContainer {
  label?: string;
  textAlign?: "left" | "center" | "right";
  isCollapsible?: boolean;
  isInitiallyCollapsed?: boolean;
  children: ReactNode;
  additionalClassName?: string;
}

/**
 * Meant to be part of a set of generic highly reusable UI tools located in /components/common/tools. The purpose of this
 * component is to provide a generic standardized pre-styled way of visually grouping content. It also provides commonly
 * used container functionality such as text-alignment, collapsibility, and a title bar.
 */
export default function Container({label, children, textAlign = "center", isCollapsible = false, isInitiallyCollapsed = false, additionalClassName = ""}: IContainer) {
  const [isBodyDisplayed, setIsBodyDisplayed] = useState<boolean>(!isInitiallyCollapsed);
  let textAlignClass = s.centerAligned;
  switch (textAlign) {
    case "left":
      textAlignClass = s.leftAligned;
      break;
    case "right":
      textAlignClass = s.rightAligned;
      break;
  }

  const bodyClass = isBodyDisplayed ? s.bodyDisplayed : s.bodyHidden;

  return (
    <div className={`${s.container} ${additionalClassName}`}>
      <div className={s.titleBar} onClick={() => {
        setIsBodyDisplayed(!isBodyDisplayed);
      }}>
        {
          isCollapsible
            ? <span
              className={s.collapseButton}>
              <div className={s.detailsButton}>
                <FontIcon icon={isBodyDisplayed ? "icon-angle-down" : "icon-angle-right"} />
              </div>
            </span>
            : null
        }
        {
          label
            ?
            <span className={s.title}>{label}</span>
            :
            null
        }
      </div>
      <div className={`${s.innerContainer} ${textAlignClass} ${bodyClass}`}>
        {children}
      </div>
    </div>
  );
}
